import React from "react";
import RegisterPage from "../components/RegisterPage";
import { useHSE } from "../lib/store";

const TYPE = {
  Internal: { bg: "#DBEAFE", color: "#1E40AF" },
  External: { bg: "#FEF3C7", color: "#854D0E" },
};
const STATUS = {
  Open: { bg: "#FEF3C7", color: "#854D0E" },
  "In Progress": { bg: "#DBEAFE", color: "#1E40AF" },
  Closed: { bg: "#DCFCE7", color: "#166534" },
};

export default function Audits() {
  const { data, siteNames } = useHSE();
  const intC = data.audits.filter((a) => a.type === "Internal").length;
  const extC = data.audits.filter((a) => a.type === "External").length;
  const avgScore = data.audits.length ? Math.round(data.audits.reduce((a, b) => a + b.score, 0) / data.audits.length) : 0;
  const totalFindings = data.audits.reduce((a, b) => a + b.findings, 0);

  const Top = (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
      <Stat label="Internal Audits" value={intC} />
      <Stat label="External Audits" value={extC} />
      <Stat label="Avg Score" value={`${avgScore}%`} tone={avgScore >= 85 ? "safe" : "warning"} />
      <Stat label="Total Findings" value={totalFindings} tone="warning" />
    </div>
  );

  return (
    <RegisterPage
      title="Audit & Follow-up"
      subtitle="HSSE internal audit, CSMS audit, incident investigation and follow-up closeout"
      storeKey="audits"
      idPrefix="AUD"
      topPanels={Top}
      columns={[
        { key: "id", label: "Audit ID" },
        { key: "date", label: "Date" },
        { key: "site", label: "Site" },
        { key: "type", label: "Type" },
        { key: "auditor", label: "Auditor" },
        { key: "scope", label: "Scope" },
        { key: "findings", label: "Findings" },
        { key: "score", label: "Score", render: (r) => <span className="tabular font-semibold">{r.score}%</span> },
        { key: "ncrRaised", label: "NCRs" },
        { key: "actionRequired", label: "Action?" },
        { key: "status", label: "Status" },
      ]}
      badgeMap={{ type: TYPE, status: STATUS }}
      formFields={[
        { key: "id", label: "Audit ID" },
        { key: "date", label: "Date", type: "date" },
        { key: "site", label: "Site", type: "select", options: siteNames },
        { key: "type", label: "Type", type: "select", options: ["Internal", "External"] },
        { key: "auditor", label: "Auditor" },
        { key: "scope", label: "Scope", type: "select", options: ["ISO 45001", "ISO 14001", "OSHA", "Internal SOPs", "Contractor"] },
        { key: "findings", label: "Findings (count)", type: "number" },
        { key: "score", label: "Score (%)", type: "number" },
        { key: "ncrRaised", label: "NCRs Raised", type: "number" },
        { key: "actionRequired", label: "Action Required", type: "select", options: ["Yes", "No"] },
        { key: "status", label: "Status", type: "select", options: ["Open", "In Progress", "Closed"] },
      ]}
    />
  );
}

function Stat({ label, value, tone = "neutral" }) {
  const c = { safe: "#54A57B", warning: "#FFB517", critical: "#DC2626", neutral: "#183C55" }[tone];
  return (
    <div className="command-card p-3.5 border-l-4" style={{ borderLeftColor: c }}>
      <div className="text-[10px] uppercase tracking-wider text-slate-500 font-semibold">{label}</div>
      <div className="font-heading font-bold text-2xl tabular text-[#0E2336] mt-0.5">{value}</div>
    </div>
  );
}
